import { createAction, props } from '@ngrx/store';
import {
	PagedResultsOfUser,
	UserListArgs,
	User,
	PagedResultsOfUserRegistrationRequest,
	UserRegistrationRequestListArgs,
	UserRegistrationRequest,
} from 'src/shared/api';
import { TouchableControl } from 'src/shared/models/TouchableControl';

export const customerUsersListDestroyed = createAction(
	'[Customer User List] Customer User List Destroyed'
);

export const pagedCustomerUsersLoaded = createAction(
	'[Customer User List] Customer Users Loaded',
	props<{
		pagedCustomerUsers: PagedResultsOfUser;
		listArgs: UserListArgs;
	}>()
);

export const errorLoadingCustomerUsers = createAction(
	'[Customer User List] Error Loading Customer Users',
	props<{ error: any }>()
);

export const filtersUpdated = createAction(
	'[Customer User List] Filters Updated',
	props<{ filters: UserListArgs }>()
);

export const navigatedWithoutAnyParams = createAction(
	'[Customer User List] Navigated Without Any Params',
	props<{ listArgs: UserListArgs }>()
);

export const navigatedWithoutPagingParams = createAction(
	'[Customer User List] Navigated Without Paging Params',
	props<{ listArgs: UserListArgs }>()
);

export const customerUserSaved = createAction(
	'[Customer User] Customer User Saved',
	props<{ user: User }>()
);

export const saveRequestedWithInvalidForm = createAction(
	'[Customer User] Save Requested With Invalid Form',
	props<{ controls: TouchableControl[] }>()
);

export const formErrorCleared = createAction(
	'[Customer User] Form Error Cleared'
);

export const newCustomerUserSaved = createAction(
	'[Customer User] New Customer User Saved',
	props<{ user: User }>()
);

export const errorSavingCustomerUser = createAction(
	'[Customer User] Error Saving Customer User',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Customer User] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: User }>()
);

export const customerUserDetailDestroyed = createAction(
	'[Customer User] Customer User Detail Destroyed'
);

export const registrationRequestsListDestroyed = createAction(
	'[Registration Requests] Registration Request List Destroyed'
);

export const customerUserSelected = createAction(
	'[Customer User] Customer User Selected',
	props<{ selectedUserId: string }>()
);

export const customerUserLoadedFromApi = createAction(
	'[Customer User] Customer User Loaded From Api',
	props<{ user: User }>()
);

export const customerUserLoadedFromStore = createAction(
	'[Customer User] Customer User Loaded From Store',
	props<{ user: User }>()
);

export const errorLoadingCustomerUser = createAction(
	'[Customer User] Error Loading Customer User',
	props<{ error: any }>()
);

export const pagedRegistrationRequestsRequested = createAction(
	'[Registration Request List] Registration Request Requested',
	props<{
		listArgs: UserRegistrationRequestListArgs;
	}>()
);

export const pagedRegistrationRequestsLoaded = createAction(
	'[Registration Request List] Registration Request Loaded',
	props<{
		pagedRegistrationRequests: PagedResultsOfUserRegistrationRequest;
	}>()
);

export const registrationRequestDenied = createAction(
	'[Registration Request List] Registration Request Denied',
	props<{ id: number }>()
);

export const registrationRequestDenyCompleted = createAction(
	'[Registration Request List] Registration Request Deny Completed',
	props<{ registrationRequest: UserRegistrationRequest }>()
);

export const registrationRequestSelected = createAction(
	'[Registration Request] Registration Request Selected',
	props<{ registrationRequestId: number }>()
);
